import {all, call, fork, put} from "redux-saga/effects";
import {apiClient} from 'util/Api'
import {
    ADD_CUSTOMER, CREATE_USER_FOR_CUSTOMER,
    CUSTOMER_MODULE_ACTIVATE,
    CUSTOMER_MODULE_DEACTIVATE,
    CUSTOMER_SUBSCRIPTION_ACTIVATE,
    CUSTOMER_SUBSCRIPTION_DEACTIVATE, DELETE_USER_FOR_CUSTOMER, DELETE_USER_FOR_CUSTOMER_INVITE,
    FETCH_ATTACK,
    FETCH_ATTACKS,
    FETCH_CAMPAIGNS,
    FETCH_CUSTOMERS,
    FETCH_EVENTS,
    FETCH_PERIMETER_ATTACKS_META,
    FETCH_TARGET,
    FETCH_TARGETS, FETCH_USERS_FOR_CUSTOMER,
    FETCH_VECTORS,
    SET_STROMBOLI_ON,
    SET_TARGET_SCOPE, UPDATE_CUSTOMER_NAME
} from "constants/ActionTypes";
import {

    fetchCustomersSuccess,
    fetchCustomersFail,
    setStromboliOffSuccess,
    fetchVectorsSuccess,
    fetchVectorsFail,
    fetchTargetFail,
    fetchTargetSuccess,
    fetchEventsSuccess,
    fetchEventsFail,
    fetchAttacksSuccess,
    fetchAttacksFail,
    fetchCampaignsSuccess,
    fetchCampaignsFail,
    fetchPerimeterAttacksMetaSuccess,
    fetchPerimeterAttacksMetasFail,
    fetchAttackSuccess,
    fetchAttackFail,
    addNewCustomerSuccess,
    addNewCustomerFail,
    setTargetScopeSuccess,
    setTargetScopeFail,
    deactivateCustomerModuleFail,
    deactivateCustomerModuleSuccess,
    activateCustomerModuleFail,
    activateCustomerModuleSuccess,
    activateCustomerSubscriptionSuccess,
    activateCustomerSubscriptionFail,
    deactivateCustomerSubscriptionSuccess,
    deactivateCustomerSubscriptionFail,
    fetchUsersForCustomerSuccess,
    fetchUsersForCustomerFail,
    createUserForCustomerSuccess,
    createUserForCustomerFail,
    deleteUserForCustomerSuccess,
    deleteUserForCustomerFail,
    deleteUserForCustomerInviteFail,
    deleteUserForCustomerInviteSuccess,
    updateCustomerNameSuccess, updateCustomerNameFail, updateCustomerName
} from "actions/Customer";
import {takeLatest, takeLeading, takeEvery} from "@redux-saga/core/effects";
import {
    fetchHumansFail,
    fetchHumansSuccess,
    fetchTargetsFail,
    fetchTargetsSuccess,
    setStromboliOffFail,
    setStromboliOnFail,
    setStromboliOnSuccess
} from "../actions";
import {bbStandardRequestHandler} from "../util/bbHelpers";
import {FETCH_HUMANS, SET_STROMBOLI_OFF} from "../constants/ActionTypes";

/* ***************************
   Fetching customer data
   *************************** */

const getCustomerDataRequest = async () =>
    await  apiClient.get('/customer/list', {timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);

function* getCustomersGenerator() {
    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "fetchCustomers";     console.group(`${standardName} Generator...: `);
    // const {customerId, firstName, lastName, email, isManager } = payload;
    const request = yield call(getCustomerDataRequest);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, false, true);

    if (didRequestSucceed) {
        yield put(fetchCustomersSuccess(request.data.customers));
    } else {
        yield put(fetchCustomersFail(request));
    }

    console.groupEnd();
}


export function* watchLeadingGetCustomerData() {
    yield takeLeading(FETCH_CUSTOMERS, getCustomersGenerator);
}

/* ***************************
   adding new customers
   *************************** */

const addNewCustomerRequest = async (domains, ips, poc_name, poc_email, poc_phone, service_requested, name, comments, customer_size, customer_industry, subscription_start, subscription_end, name_short) =>
    await  apiClient.post('/customer/new', {
            domains: domains,
            ips: ips,
            poc_name: poc_name,
            poc_email: poc_email,
            poc_phone: poc_phone,
            service_requested: service_requested,
            name: name,
            comments: comments,
            customer_size: customer_size,
            customer_industry: customer_industry,
            subscription_start: subscription_start,
            subscription_end: subscription_end,
            name_short: name_short
        },
        {timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);

function* addNewCustomerGenerator({payload}) {
    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "addNewCustomer";     console.group(`${standardName} Generator...: `);
    const {
        domains,
        ips,
        poc_name,
        poc_email,
        poc_phone,
        service_requested,
        name,
        comments,
        customer_size,
        customer_industry,
        subscription_start,
        subscription_end,
        name_short
    } = payload;
    const request = yield call(addNewCustomerRequest, domains, ips, poc_name, poc_email, poc_phone, service_requested, name, comments, customer_size, customer_industry, subscription_start, subscription_end, name_short);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, true, true);

    if (didRequestSucceed) {
        yield put(addNewCustomerSuccess(
            {
                inboundData: request.data,
            }));
    } else {
        yield put(addNewCustomerFail(request));
    }

    console.groupEnd();
}


export function* watchLeadingAddNewCustomer() {
    yield takeLeading(ADD_CUSTOMER, addNewCustomerGenerator);
}

/* ***************************
   Fetching target summary data for a given customer
   *************************** */

const getCustomerTargetsSummaryDataRequest = async (customerId, pageNumber = 1) =>
    await  apiClient.get(`/target/customer/${customerId}/summary${pageNumber ? `/${pageNumber}` : ''}`, {timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);

function* getCustomerTargetsSummaryGenerator({payload}) {

    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "getCustomerTargetsSummary";     console.group(`${standardName} Generator...: `);
    const {customerId, pageNumber} = payload;
    if (customerId) {
        const request = yield call(getCustomerTargetsSummaryDataRequest, customerId, pageNumber);
        /*  ******END*******************/

        const didRequestSucceed = bbStandardRequestHandler(request, standardName, false, false);

        if (didRequestSucceed) {
            yield put(fetchTargetsSuccess(
                {
                    customerId: customerId,
                    inboundData: request.data.targets,
                    inboundMeta: request.data.totals,
                }));
        } else {
            yield put(fetchTargetsFail(request));
        }
    }

    console.groupEnd();
}

export function* watchLeadingGetCustomerTargetsSummaryData() {
    yield takeLeading(FETCH_TARGETS, getCustomerTargetsSummaryGenerator);
}

/* ***************************
   Fetching target summary data for a given customer
   *************************** */

const getCustomerTargetRequest = async (targetId) =>
    await  apiClient.get(`/target/${targetId}`, {timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);

function* getCustomerTargetGenerator({payload}) {

    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "getCustomerTarget";     console.group(`${standardName} Generator...: `);
    const {customerId, targetId} = payload;
    if (customerId && targetId) {
        const request = yield call(getCustomerTargetRequest, targetId);
        /*  ******END*******************/

        const didRequestSucceed = bbStandardRequestHandler(request, standardName, false, false);

        if (didRequestSucceed) {
            yield put(fetchTargetSuccess(
                {
                    customerId: customerId,
                    targetId: targetId,
                    target: request.data
                }));
        } else {
            yield put(fetchTargetFail(request));
        }
    }

    console.groupEnd();
}

export function* watchLeadingGetCustomerTargetData() {
    yield takeLeading(FETCH_TARGET, getCustomerTargetGenerator);
}

/* ***************************
   Fetching human identities summary data for a given customer
   *************************** */

const getCustomerHumansSummaryDataRequest = async (customerId) =>
    await  apiClient.get(`/customer/${customerId}/identity/summary`, {timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);

function* getCustomerHumansSummaryGenerator({payload}) {

    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "getCustomerHumansSummary";     console.group(`${standardName} Generator...: `);
    const {customerId} = payload;
    if (customerId) {
        const request =  yield call(getCustomerHumansSummaryDataRequest, customerId);
        /*  ******END*******************/

        const didRequestSucceed = bbStandardRequestHandler(request, standardName, false, false);

        if (didRequestSucceed) {
            yield put(fetchHumansSuccess(
                {
                    customerId: customerId,
                    inboundData: request.data.identities
                }));
        } else {
            yield put(fetchHumansFail(request));
        }

    }
    console.groupEnd();
}

export function* watchLeadingGetCustomerHumansSummaryData() {
    yield takeLeading(FETCH_HUMANS, getCustomerHumansSummaryGenerator);
}

/* ***************************
   Fetching vectors for a given customer
   *************************** */

const getCustomerVectorsSummaryDataRequest = async (customerId) =>
    await  apiClient.get(`/perimeter/customer/${customerId}/summary`, {timeout: 45000}
    )
        .then(data => data)
        .catch(error => error);

function* getCustomerVectorsSummaryGenerator({payload}) {

    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "getCustomerVectorsSummary";     console.group(`${standardName} Generator...: `);
    const {customerId} = payload;
    // console.log("customerId is", customerId, "from payload", payload);
    if (customerId) {
        const request =  yield call(getCustomerVectorsSummaryDataRequest, customerId);
        /*  ******END*******************/

        const didRequestSucceed = bbStandardRequestHandler(request, standardName, false, false);

        if (didRequestSucceed) {
            yield put(fetchVectorsSuccess(
                {
                    customerId: customerId,
                    inboundData: request.data.vectors
                }));
        } else {
            yield put(fetchVectorsFail());
        }
    }

    console.groupEnd();
}

export function* watchLeadingGetCustomerVectorsSummaryData() {
    yield takeLeading(FETCH_VECTORS, getCustomerVectorsSummaryGenerator);
}

/* ***************************
   Fetching perimeter attack meta for a given customer
   *************************** */
//example response 05 Jan 2021
// {
//     "attacks": {
//         "total": {
//             "attacks": 1,
//                 "perimeter": 0,
//                 "perimeter_defeated": 0,
//                 "phishing": 1,
//                 "phishing_defeated": 0
//         },
//         "30_days": {
//             "attacks": 0,
//                 "perimeter": 0,
//                 "perimeter_defeated": 0,
//                 "phishing": 0,
//                 "phishing_defeated": 0
//         }
//     }
// }

const getCustomerPerimeterAttacksMetaDataRequest = async (customerId) =>
    await  apiClient.get(`/attack/v2/customer/${customerId}/totals`, {timeout: 45000}
    )
        .then(data => data)
        .catch(error => error);

function* getCustomerPerimeterAttacksMetaGenerator({payload}) {

    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "getCustomerPerimeterAttacksMeta";     console.group(`${standardName} Generator...: `);
    const {customerId} = payload;
    // console.log("customerId is", customerId, "from payload", payload);
    if (customerId) {
        const request =  yield call(getCustomerPerimeterAttacksMetaDataRequest, customerId);
        /*  ******END*******************/

        const didRequestSucceed = bbStandardRequestHandler(request, standardName, false, false);

        if (didRequestSucceed) {
            yield put(fetchPerimeterAttacksMetaSuccess(
                {
                    customerId: customerId,
                    inboundData: request.data.attacks
                }));
        } else {
            yield put(fetchPerimeterAttacksMetasFail());
        }
    }

    console.groupEnd();
}

export function* watchLeadingGetCustomerPerimeterAttacksMetaData() {
    yield takeLeading(FETCH_PERIMETER_ATTACKS_META, getCustomerPerimeterAttacksMetaGenerator);
}

/* ***************************
   Fetching phishing campaign vectors for a given customer
   *************************** */

const getCustomerCampaignsSummaryDataRequest = async (customerId) =>
    await  apiClient.get(`/campaign/customer/${customerId}/summary`, {timeout: 30000}
    )
        .then(data => data)
        .catch(error => error);

function* getCustomerCampaignsSummaryGenerator({payload}) {

    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "getCustomerCampaignsSummary";     console.group(`${standardName} Generator...: `);
    const {customerId} = payload;
    if (customerId) {
        const request =  yield call(getCustomerCampaignsSummaryDataRequest, customerId);
        /*  ******END*******************/

        const didRequestSucceed = bbStandardRequestHandler(request, standardName, false, false);

        if (didRequestSucceed) {
            yield put(fetchCampaignsSuccess(
                {
                    customerId: customerId,
                    inboundData: request.data.campaigns,
                    inboundMeta: request.data.totals,
                }));
        } else {
            yield put(fetchCampaignsFail());
        }
    }

    console.groupEnd();
}

export function* watchLeadingGetCustomerCampaignsSummaryData() {
    yield takeLeading(FETCH_CAMPAIGNS, getCustomerCampaignsSummaryGenerator);
}

/* ***************************
   Fetching attacks for a given vector
   *************************** */

const getVectorAttacksSummaryDataRequest = async (vectorId, pageNumber = 1) =>
    await  apiClient.get(`/perimeter/vector/${vectorId}/summary${pageNumber ? `/${pageNumber}` : ''}`, {timeout: 45000}
    )
        .then(data => data)
        .catch(error => error);

function* getVectorAttacksSummaryGenerator({payload}) {

    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "getVectorAttacksSummary";     console.group(`${standardName} Generator...: `);
    const {customerId, vectorId, pageNumber} = payload;
    if (customerId &&  vectorId) {
        const request =  yield call(getVectorAttacksSummaryDataRequest, vectorId, pageNumber);
        /*  ******END*******************/

        const didRequestSucceed = bbStandardRequestHandler(request, standardName, false, false);

        // console.log("Got this from getVectorAttacksSummaryGenerator request.data", request.data)
        if (didRequestSucceed) {
            yield put(fetchAttacksSuccess(
                {
                    customerId: customerId,
                    vectorId: vectorId,
                    inboundData: request.data.Attacks,
                    inboundMeta: request.data["Attack Totals"],
                }));
        } else {
            yield put(fetchAttacksFail());
        }
    }

    console.groupEnd();
}

export function* watchLeadingGetVectorAttacksSummaryData() {
    yield takeLeading(FETCH_ATTACKS, getVectorAttacksSummaryGenerator);
}

/* ***************************
   Fetching a single attack by id for a given vector
   *************************** */

const getVectorAttackDetailRequest = async (attackId) =>
    await  apiClient.get(`/attack/v2/${attackId}`, {timeout: 45000}
    )
        .then(data => data)
        .catch(error => error);

function* getVectorAttackDetailGenerator({payload}) {

    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "getVectorAttackDetail";     console.group(`${standardName} Generator...: `);
    const {customerId, attackId} = payload;
    const request =  yield call(getVectorAttackDetailRequest, attackId);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, false, true);

    if (didRequestSucceed) {
        //if a campaignId was sent, this is a campaign attack
        const typeId = request.data.PerimeterAttackId ? "vectorId" : "campaignId"
        const idValue = request.data.PerimeterAttackId ? request.data["Perimeter Attack Detail"]["Attack Vector"].Id : request.data["Phishing Attack Detail"]["Campaign Id"];
        console.log("created typeId and idValue of", typeId, idValue)
        yield put(fetchAttackSuccess(
            {
                customerId: customerId,
                [typeId]: idValue,
                attackId: attackId,
                inboundData: request.data
            }));
    } else {
        yield put(fetchAttackFail());
    }

    console.groupEnd();
}

export function* watchLeadingGetVectorAttackDetail() {
    yield takeLeading(FETCH_ATTACK, getVectorAttackDetailGenerator);
}

/*  jfd*******************************
 *   setTargetScopeRequest used toggle oos or in scope of a target
     ********************************** */
const setTargetScopeRequest = async (targetId, newScopeStatus) =>
    await  apiClient.put(`/target/${targetId}`,{
            OutOfScope: newScopeStatus === true || newScopeStatus === 1 ? 1 : 0,
        },{timeout: 25000}
    )
        .then(token => token)
        .catch(error => error);

function* setTargetScopeGenerator({payload}) {

    /*  jfd*******************************
 *   Modify these parameters AND the fail and success cases below
     ********************************** */
    const standardName = "setTargetScope";     console.group(`${standardName} Generator...: `);
    const {customerId, targetId, newScopeStatus} = payload;
    const request = yield call(setTargetScopeRequest, targetId, newScopeStatus);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, true, true);

    if (didRequestSucceed) {
        yield put(setTargetScopeSuccess(
            {
                //TODO: MAKE THESE PULL FROM THE REQUEST ONCE JOHN SENDS BACK FULL DATA
                customerId: customerId,
                targetId: targetId,
                inboundData: request.data
                // customerId: request.data.CustomerId,
                // targetId: request.data.TargetId,
                // inboundData: request.data
            }));
    } else {
        yield put(setTargetScopeFail(
            {
                //TODO: MAKE THESE PULL FROM THE REQUEST ONCE JOHN SENDS BACK FULL DATA
                customerId: customerId,
                targetId: targetId,
                // customerId: request.data.CustomerId,
                // targetId: request.data.TargetId,
                inboundData: request.data
            }
        ));
    }

    console.groupEnd();
}

export function* watchEverySetTargetScope() {
    yield takeEvery(SET_TARGET_SCOPE, setTargetScopeGenerator);
}

/* ***************************
   Setting the Stromboli State (turning on and off continous service)
   *************************** */

const setStromboliStatusRequest = async (customerId, newStatus) =>
    await  apiClient.put(`/stromboli/${customerId}`, {"Service Active": newStatus}
    )
        .then(data => data)
        .catch(error => error);

function* setStromboliStatusGenerator({payload}) {

    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "setStromboliStatus";     console.group(`${standardName} Generator...: `);
    const {customerId, newStatus} = payload;
    const request = yield call(setStromboliStatusRequest, customerId, newStatus);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, true, false);

    if (didRequestSucceed) {
        if (newStatus === "0") {
            yield put(setStromboliOffSuccess(request.data));
        } else {
            yield put(setStromboliOnSuccess(request.data));
        }
    } else {
        if (newStatus === "0") {
            yield put(setStromboliOffFail());
        } else {
            yield put(setStromboliOnFail());
        }
    }

    console.groupEnd();
}

export function* watchLatestSetStromboliStatus() {
    //TODO: upgrade this to takeEvery so that mulitple requests can be made simultaneously (and status of request tracked)
    yield takeLatest(SET_STROMBOLI_ON, setStromboliStatusGenerator);
    yield takeLatest(SET_STROMBOLI_OFF, setStromboliStatusGenerator);
}

/* ***************************
   Fetching event batches
   *************************** */

const getCustomerEventsRequest = async (customerId, pageNumber = 1) =>
    await  apiClient.get(`/events/customer/${customerId}${pageNumber ? `/${pageNumber}` : ''}`, {timeout: 45000}
    )
        .then(data => data)
        .catch(error => error);

function* getCustomerEventsGenerator({payload}) {

    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "getCustomerEvents";     console.group(`${standardName} Generator...: `);
    const {customerId, pageNumber} = payload;
    const useThisPageNumber = pageNumber ? pageNumber : 1;
    // const rangeStart = Number.parseInt(useThisPageNumber) * 10 - 10;
    // const rangeEnd = Number.parseInt(useThisPageNumber) * 10 - 1;
    // console.log("events generator capture page numbers from ", pageNumber, "converted to ", rangeStart, rangeEnd)
    if (customerId) {
        const request =  yield call(getCustomerEventsRequest, customerId, useThisPageNumber);
        /*  ******END*******************/

        const didRequestSucceed = bbStandardRequestHandler(request, standardName, false, false);

        if (didRequestSucceed) {
            yield put(fetchEventsSuccess(
                {
                    customerId: customerId,
                    inboundData: request.data.events,
                    inboundMeta: request.data.totals,
                    pageNumber: useThisPageNumber
                }));
        } else {
            yield put(fetchEventsFail());
        }
    }

    console.groupEnd();
}

export function* watchLeadingGetCustomerEvents() {
    yield takeLeading(FETCH_EVENTS, getCustomerEventsGenerator);
}



/* ***************************
   ACTIVATE A CUSTOMER MODULE
   *************************** */

const activateCustomerModuleRequest = async (customerId, moduleId) =>
    await  apiClient.post(`/customer/${customerId}/module`,
        {
            // CustomerId: customerId,
            Module: moduleId,
        },{timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);

function* activateCustomerModuleGenerator({payload}) {
    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "activateCustomerModule";     console.group(`${standardName} Generator...: `);
    const {customerId, moduleId } = payload;
    const request = yield call(activateCustomerModuleRequest, customerId, moduleId);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, true, true);

    if (didRequestSucceed) {
        yield put(
            activateCustomerModuleSuccess(
                {
                    inboundData: request.data.Modules,
                    moduleId: moduleId,
                    customerId : customerId,
                }
            )
        );
    } else {
        yield put(activateCustomerModuleFail({
            inboundData: request.data,
            moduleId: moduleId
        }));
    }

    console.groupEnd();
}


export function* watchLatestActivateCustomerModule() {
    yield takeLatest(CUSTOMER_MODULE_ACTIVATE, activateCustomerModuleGenerator);
}

/* ***************************
   DEACTIVATE A CUSTOMER MODULE
   *************************** */

const deactivateCustomerModuleRequest = async (customerId, moduleId) =>
    await  apiClient.delete(`/customer/${customerId}/module`,
        { data :{
                Module: moduleId,
            }
        },{timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);

function* deactivateCustomerModuleGenerator({payload}) {
    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "deactivateCustomerModule";     console.group(`${standardName} Generator...: `);
    const {customerId, moduleId } = payload;
    const request = yield call(deactivateCustomerModuleRequest, customerId, moduleId);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, true, true);

    if (didRequestSucceed) {
        yield put(
            deactivateCustomerModuleSuccess(
                {
                    inboundData: request.data.Modules,
                    moduleId: moduleId,
                    customerId : customerId,
                }
            )
        );
    } else {
        yield put(deactivateCustomerModuleFail({
            inboundData: request.data,
            moduleId: moduleId
        }));
    }

    console.groupEnd();
}


export function* watchLatestDeactivateCustomerModule() {
    yield takeLatest(CUSTOMER_MODULE_DEACTIVATE, deactivateCustomerModuleGenerator);
}

/* ***************************
   ACTIVATE A CUSTOMER SUBSCRIPTION
   *************************** */

const activateCustomerSubscriptionRequest = async (customerId) =>
    await  apiClient.put(`/customer/${customerId}`,
        {
            // CustomerId: customerId,
            ["Subscription Active"]: true,
        },{timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);

function* activateCustomerSubscriptionGenerator({payload}) {
    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "activateCustomerSubscription";     console.group(`${standardName} Generator...: `);
    const {customerId } = payload;
    const request = yield call(activateCustomerSubscriptionRequest, customerId);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, true, true);

    if (didRequestSucceed) {
        yield put(
            activateCustomerSubscriptionSuccess(
                {
                    // inboundData: request.data.Subscriptions,
                    // moduleId: moduleId,
                    customerId : customerId,
                }
            )
        );
    } else {
        yield put(activateCustomerSubscriptionFail({
            // inboundData: request.data,
            // moduleId: moduleId
            customerId : customerId,
        }));
    }

    console.groupEnd();
}


export function* watchLatestActivateCustomerSubscription() {
    yield takeLatest(CUSTOMER_SUBSCRIPTION_ACTIVATE, activateCustomerSubscriptionGenerator);
}

/* ***************************
   DEACTIVATE A CUSTOMER SUBSCRIPTION
   *************************** */

const deactivateCustomerSubscriptionRequest = async (customerId) =>
    await  apiClient.put(`/customer/${customerId}`,
        {
            // CustomerId: customerId,
            ["Subscription Active"]: false,
        },{timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);

function* deactivateCustomerSubscriptionGenerator({payload}) {
    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "deactivateCustomerSubscription";     console.group(`${standardName} Generator...: `);
    const {customerId } = payload;
    const request = yield call(deactivateCustomerSubscriptionRequest, customerId);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, true, true);

    if (didRequestSucceed) {
        yield put(
            deactivateCustomerSubscriptionSuccess(
                {
                    // inboundData: request.data.Subscriptions,
                    // moduleId: moduleId,
                    customerId : customerId,
                }
            )
        );
    } else {
        yield put(deactivateCustomerSubscriptionFail({
            // inboundData: request.data,
            // moduleId: moduleId,
            customerId : customerId,
        }));
    }

    console.groupEnd();
}


export function* watchLatestDeactivateCustomerSubscription() {
    yield takeLatest(CUSTOMER_SUBSCRIPTION_DEACTIVATE, deactivateCustomerSubscriptionGenerator);
}

/*  sarahp**********06.09.22*****
*  Get Users for Customer
                 **********************  */
const getUsersForCustomerRequest = async (customerId) =>
    await  apiClient.get(`/user/customer/${customerId}`, {timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);

function* getUsersForCustomerGenerator({payload}) {
    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "fetchUsersForCustomer";     console.group(`${standardName} Generator...: `);
    const {customerId,} = payload;
    const request = yield call(getUsersForCustomerRequest, customerId);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, false, true);

    if (didRequestSucceed) {
        yield put(fetchUsersForCustomerSuccess({
            customerId: customerId,
            inboundData: request.data
        }));
    } else {
        yield put(fetchUsersForCustomerFail({
            request: request.data,
        }));
    }

    console.groupEnd();
}


export function* watchLeadingGetUsersForCustomerData() {
    yield takeLeading(FETCH_USERS_FOR_CUSTOMER, getUsersForCustomerGenerator);
}

/*  sarahp**********06.09.22*****
 *  POST Users for Customer
     **********************  */

const createUserForCustomerRequest = async (customerId, email, isManager, firstName, lastName) =>
    await  apiClient.post(`/user/customer/${customerId}`, {
        customerId: customerId,
        email: email,
        manager: isManager,
        first_name: firstName,
        last_name: lastName,
    }, {timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);

function* createUserForCustomerGenerator({payload}) {
    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "createUserForCustomer";     console.group(`${standardName} Generator...: `);
    const {customerId, email, isManager, firstName, lastName} = payload;
    const request = yield call(createUserForCustomerRequest, customerId, email, isManager, firstName, lastName);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, true, true);

    if (didRequestSucceed) {
        yield put(createUserForCustomerSuccess({
            customerId: customerId,
            inboundData: request.data
        }));
    } else {
        yield put(createUserForCustomerFail({
            request: request.data,
        }));
    }

    console.groupEnd();
}


export function* watchLeadingCreateUserForCustomerGenerator() {
    yield takeLeading(CREATE_USER_FOR_CUSTOMER, createUserForCustomerGenerator);
}

/*  sarahp**********06.09.22*****
 *  DEL Users for Customer
     **********************  */

const deleteUserForCustomerRequest = async (customerId, idToDelete,) =>
    await  apiClient.delete(`/user/customer/${customerId}`, {
    data:{
        customerId: customerId,
        user_map: idToDelete,
    }
}, {timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);

function* deleteUserForCustomerGenerator({payload}) {
    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "deleteUserForCustomer";     console.group(`${standardName} Generator...: `);
    const {customerId, idToDelete, } = payload;
    const request = yield call(deleteUserForCustomerRequest, customerId, idToDelete, );
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, false, true);

    if (didRequestSucceed) {
        yield put(deleteUserForCustomerSuccess({
            customerId: customerId,
            inboundData: request.data
        }));
    } else {
        yield put(deleteUserForCustomerFail({
            request: request.data,
        }));
    }

    console.groupEnd();
}


export function* watchLeadingDeleteUserForCustomerGenerator() {
    yield takeLeading(DELETE_USER_FOR_CUSTOMER, deleteUserForCustomerGenerator);
}
/*  sarahp**********12.09.22*****
 *  DEL Users for Customer-- INVITE ONLY
     **********************  */

const deleteUserForCustomerInviteRequest = async (customerId, idToDelete, ) =>
    await  apiClient.delete(`/user/customer/${customerId}`, {data: {
            customerId: customerId,
            invitation: idToDelete,
        }}, {timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);

function* deleteUserForCustomerInviteGenerator({payload}) {
    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "deleteUserForCustomerInvite";     console.group(`${standardName} Generator...: `);
    const {customerId, idToDelete,} = payload;
    const request = yield call(deleteUserForCustomerInviteRequest, customerId, idToDelete,);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, false, true);

    if (didRequestSucceed) {
        yield put(deleteUserForCustomerInviteSuccess({
            customerId: customerId,
            inboundData: request.data
        }));
    } else {
        yield put(deleteUserForCustomerInviteFail({
            request: request.data,
        }));
    }

    console.groupEnd();
}


export function* watchLeadingDeleteUserForCustomerInviteGenerator() {
    yield takeLeading(DELETE_USER_FOR_CUSTOMER_INVITE, deleteUserForCustomerInviteGenerator);
}

/*  sarahp**********07.05.2023*****
 *  Update Customer Name
     **********************  */

const updateCustomerNameRequest = async (customerId, customerName, ) =>
    await  apiClient.put(`/customer/${customerId}?CustomerName=${customerName}`, {timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);

function* updateCustomerNameGenerator({payload}) {
    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "updateCustomerName";     console.group(`${standardName} Generator...: `);
    const {customerId, customerName} = payload;
    const request = yield call(updateCustomerNameRequest, customerId, customerName);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, true, true);

    if (didRequestSucceed) {
        yield put(updateCustomerNameSuccess({
            customerId: customerId,
            customerName: customerName,
            inboundData: request.data
        }));
    } else {
        yield put(updateCustomerNameFail({
            request: request.data,
        }));
    }

    console.groupEnd();
}


export function* watchEveryUpdateCustomerNameGenerator() {
    yield takeLeading(UPDATE_CUSTOMER_NAME, updateCustomerNameGenerator);
}

/* ***************************
   root Saga
   *************************** */

export default function* rootSaga() {
    yield all([
        fork(watchLeadingGetCustomerData),
        fork(watchLatestSetStromboliStatus),
        fork(watchLeadingGetCustomerTargetsSummaryData),
        fork(watchLeadingGetCustomerHumansSummaryData),
        fork(watchLeadingGetCustomerVectorsSummaryData),
        fork(watchLeadingGetCustomerTargetData),
        fork(watchLeadingGetCustomerEvents),
        fork(watchLeadingGetVectorAttacksSummaryData),
        fork(watchLeadingGetCustomerCampaignsSummaryData),
        fork(watchLeadingGetCustomerPerimeterAttacksMetaData),
        fork(watchLeadingGetVectorAttackDetail),
        fork(watchLeadingAddNewCustomer),
        fork(watchEverySetTargetScope),
        fork(watchLatestActivateCustomerModule),
        fork(watchLatestDeactivateCustomerModule),
        fork(watchLatestDeactivateCustomerSubscription),
        fork(watchLatestActivateCustomerSubscription),
        fork(watchLeadingGetUsersForCustomerData),
        fork(watchLeadingCreateUserForCustomerGenerator),
        fork(watchLeadingDeleteUserForCustomerGenerator),
        fork(watchLeadingDeleteUserForCustomerInviteGenerator),
        fork(watchEveryUpdateCustomerNameGenerator),
    ]);
}